import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';

const stats = [
  { value: '12+', label: '专业文章' },
  { value: '6', label: '内容分类' },
  { value: '100%', label: '安全导向' },
  { value: 'SSC', label: '核心原则' },
];

const values = [
  {
    icon: 'ri-shield-check-line',
    title: '安全第一',
    desc: '我们坚信任何探索都应建立在安全的基础上。所有内容以安全为核心，涵盖风险预防、紧急处理和健康关怀。',
  },
  {
    icon: 'ri-book-open-line',
    title: '理性学习',
    desc: '知识是安全实践的基石。我们提供系统化、结构化的学习内容，从基础到进阶，帮助读者循序渐进地掌握技巧。',
  },
  {
    icon: 'ri-heart-line',
    title: '自愿原则',
    desc: '自愿是捆绑调教不可动摇的底线。我们强调沟通、同意和边界设定的重要性，倡导健康的伴侣关系。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '人文关怀',
    desc: '技术之外，我们同样关注情感连接和心理关怀。事后关怀、信任建立等内容是我们课程体系的重要组成部分。',
  },
];

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于我们"
        description="了解捆绑调教完全指南的品牌故事、核心价值观与专业信誉。我们致力于为成人伴侣提供安全、理性、自愿的捆绑调教教育内容，帮助伴侣安全探索捆绑调教的乐趣与边界。"
        keywords="捆绑调教,捆绑调教指南,捆绑调教教育,BDSM教育,捆绑调教安全,成人伴侣教育"
        canonicalUrl="/about"
        jsonLdScripts={[
          {
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于捆绑调教完全指南',
            description: '了解捆绑调教完全指南的品牌故事、核心价值观与专业信誉。',
            url: 'https://bondage-guide.com/about',
            isPartOf: { '@type': 'WebSite', name: '捆绑调教完全指南', url: 'https://bondage-guide.com' },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://bondage-guide.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://bondage-guide.com/about' },
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '捆绑调教完全指南',
            url: 'https://bondage-guide.com',
            description: '成人伴侣捆绑调教教育平台，致力于安全、理性、自愿的捆绑调教教育。',
            contactPoint: {
              '@type': 'ContactPoint',
              contactType: 'customer service',
              email: 'contact@bondage-guide.com',
              availableLanguage: ['Chinese'],
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '捆绑调教完全指南的使命是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们的使命是帮助成人伴侣在安全、自愿、理性的前提下探索捆绑调教的乐趣与边界，通过系统性的教育和指导降低风险，提升体验质量，促进健康的伴侣关系发展。',
                },
              },
            ],
          },
        ]}
      />
      <ScrollToTop />
      <Navbar />
      <main className="pt-24 pb-16 bg-background-50 min-h-screen">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mb-16">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
              关于我们
            </h1>
            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-foreground-600 leading-relaxed">
                捆绑调教完全指南是一个专注于成人伴侣捆绑调教教育的专业内容平台。
                我们的使命是帮助成人伴侣在<strong>安全（Safe）、理性（Sane）、自愿（Consensual）</strong>的SSC原则指导下，
                系统地学习捆绑调教的安全知识、技巧方法和情感经营，从而在安全的前提下探索捆绑调教的乐趣与边界。
              </p>
            </div>
          </section>

          <section className="mb-16">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70">
                  <div className="text-2xl md:text-3xl font-bold text-primary-600 mb-1">{stat.value}</div>
                  <div className="text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3 text-center">
              我们的核心价值观
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-10 max-w-xl mx-auto">
              四大核心价值观指导着我们的每一项内容和每一个决策
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {values.map((value) => (
                <div key={value.title} className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-700 mb-4">
                    <i className={`${value.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-lg font-semibold text-foreground-950 mb-2">{value.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{value.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3 text-center">
              品牌信誉
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-10 max-w-xl mx-auto">
              我们以专业、严谨的态度赢得读者的信任
            </p>
            <div className="bg-background-100 rounded-xl p-8 border border-background-200/70">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 mx-auto mb-4">
                    <i className="ri-award-line text-2xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2">专业内容</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    所有内容均由经验丰富的实践者和教育者编写，经过严格审核确保信息的准确性和安全性。
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 mx-auto mb-4">
                    <i className="ri-lock-line text-2xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2">隐私保护</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    我们尊重每一位读者的隐私，不会收集任何不必要的个人信息，所有访问数据均匿名化处理。
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 mx-auto mb-4">
                    <i className="ri-loop-left-line text-2xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2">持续更新</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    我们持续跟踪最新的安全研究和实践发展，定期更新内容，确保信息的时效性和前沿性。
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3 text-center">
              联系我们
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-10 max-w-xl mx-auto">
              如果你有任何问题、建议或合作意向，欢迎通过以下方式联系我们
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-700 mx-auto mb-4">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">电子邮件</h3>
                <p className="text-sm text-foreground-600">contact@bondage-guide.com</p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-700 mx-auto mb-4">
                  <i className="ri-question-answer-line text-xl"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">常见问题</h3>
                <p className="text-sm text-foreground-600">访问我们的FAQ页面获取常见问题解答</p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-700 mx-auto mb-4">
                  <i className="ri-hand-heart-line text-xl"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">内容贡献</h3>
                <p className="text-sm text-foreground-600">欢迎有经验的实践者加入我们的内容创作团队</p>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}